import { gsap } from "gsap";
import $ from 'jquery';

///// SCROLL PROMPT /////

// hide scroll prompt on scroll
let scrollPromptAnimation
let scrollPromptDelayTimer

if($("body").hasClass('page-template-page-sp')) {


    $(document).ready(function (){
        setupScrollPromptAnimation()

        showScrollPrompt()
        restartScrollPromptBounce()
    })

    $(window).on('scroll', function(){
        hideScrollPrompt()
        clearTimeout(scrollPromptDelayTimer)
    })

    const setupScrollPromptAnimation = () => {
        scrollPromptAnimation = gsap.timeline({
            repeat: 1,
            repeatDelay: 1.2,
            paused: true,
        })
        scrollPromptAnimation.to($('#scroll-prompt'), {
            y: -24,
            duration: 0.4,
        })
        scrollPromptAnimation.to($('#scroll-prompt'), {
            y: 0,
            duration: 0.8,
            ease: "elastic(0.9, 0.3)",
        })
    }
}

export const restartScrollPromptBounce = () => {
    scrollPromptAnimation.restart()
}

export const hideScrollPrompt = () => {
    gsap.to($('#scroll-prompt'), {
        opacity: 0
    })
}

export const showScrollPrompt = () => {
    gsap.to($('#scroll-prompt'), {
        opacity: 1
    })
}

export const showScrollPromptAfterDelay = (delay) => {
    clearTimeout(scrollPromptDelayTimer)
    scrollPromptDelayTimer = setTimeout(function(){
        showScrollPrompt()
        restartScrollPromptBounce()
        showScrollPromptAfterDelay(20000)
    }, delay)
}
